export enum UserType {
  USER = 0,
  ADMINISTRATOR = 1,
  MASTER = 3
}
